import { render, staticRenderFns } from "./VerificationFormRiskAssmnt.vue?vue&type=template&id=b1d6c7cc&"
import script from "./VerificationFormRiskAssmnt.vue?vue&type=script&lang=js&"
export * from "./VerificationFormRiskAssmnt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports